import { useLocation } from 'react-router-dom'
import useStore from 'base/store'
import {ListTabsPanel} from 'common/components'
import styles from './TopPanel.module.scss'
import {AddButton} from './AddButton'

const tabs = [
  {key: '',         label: 'Borrowers'},
  {key: 'team',     label: 'Team'},
  {key: 'brokers',  label: 'Brokers'},
]

export const TopPanel = () => {
  const {pathname} = useLocation()
  const permissions = useStore((state) => state.permissions)

  const thisTabs = !permissions?.includes('view vc org') ?
    [...tabs].filter((x:any) => x.key !== 'team') : [...tabs]

  return (
    <ListTabsPanel
      noGap
      path="orgs"
      tabs={thisTabs}
      action={(
        (
          (pathname?.indexOf('orgs/team') > -1) ||
          !permissions?.includes('create org')
        ) ? undefined :
        <div className={styles.block}>
          <AddButton />
        </div>
      ) }
    />
  )
}
